import { prefix } from "../../js/utilities";
import { matchers } from "../../js/validate-props";
import { events } from "../../js/state-machine";

export const componentName = "Modal";

export const defaultProps = Object.freeze({
    srCloseLabel: "close dialog",
    trigger: "#test",
    type: "button",
    initialState: false,
});

export const schema = Object.freeze({
    srCloseLabel: matchers.minChars(1),
    trigger: matchers.minChars(1),
    initialState: matchers.boolean,
});
export const eventMap = Object.freeze({
    opened: events.opened(componentName),
    closed: events.closed(componentName),
});

export const componentClasses = Object.freeze({
    basic: `${prefix}modal`,
    title: `${prefix}modal__title`,
    content: `${prefix}modal__content`,
    body: `${prefix}modal__body`,
    footer: `${prefix}modal__footer`,
    header: `${prefix}modal__header`,
    large: `${prefix}modal--lg`,
    show: `${prefix}modal--show`,
    closeButton: `${prefix}modal__button--close`,
});

export const views = Object.freeze({
    opened: {
        classList: [`${componentClasses.show}`],
        attrs: { "aria-hidden": "false", "aria-modal": "true" },
    },
    closed: {
        classList: [`!${componentClasses.show}`],
        attrs: { "aria-hidden": "true", "aria-modal": "false" },
    },
});
